export function getFormDataCookie() {
	return window.modUtils.getCookie('formData');
}
